// 🧿 طلسم محافظ فایل
import React from "react";
// UI Framework
import { ReloadOutlined } from "@ant-design/icons";
// Common Components
import { DynamicDropdown, Button, Modal, FileDownloader } from "src/Components";
import TableTemplate from "src/Tables/TableTemplate/tableTemplate";
import { CommonTableUI } from "src/Tables/TableTemplate/common";
// Local Components
import OrderBook from "./OrderBook";
import IVModal from "./IVModal";
// Requests
import {
  getOptionsTable,
  getOptionsSpecTable,
  getOptionsInstruments,
  getOptionExcel,
} from "src/Requests/iMEMarketWatch";
// Types
import type {
  ISelectedTableInfo,
  IUnderlyingAssetsTableReport,
  IUnderlyingAssetsSearchParams,
} from "src/Interfaces/iMEMarketWatch";

enum ModalMode {
  Details = 1,
  IV = 2,
  Closed = 3,
}
const Options = () => {
  // refs
  const prevRowRef = React.useRef<number | null>(null);
  // local states
  const [refreshFlag, setRefreshFlag] = React.useState(false);
  const [modal, setModal] = React.useState<ModalMode>(ModalMode.Closed);
  const [selectedTableInfo, setSelectedTableInfo] =
    React.useState<ISelectedTableInfo>({} as ISelectedTableInfo);
  const [searchParam, setSearchParam] =
    React.useState<IUnderlyingAssetsSearchParams>(
      {} as IUnderlyingAssetsSearchParams,
    );

  React.useEffect(() => {
    if (refreshFlag) setTimeout(() => setRefreshFlag(false), 1500);
  }, [refreshFlag]);

  const searchParamChangeHandler = (name: string, value: any) => {
    setSearchParam({ ...searchParam, [name]: value });
  };

  const handleExcelDownload = () => getOptionExcel();

  const ModalType = React.useMemo(() => {
    switch (modal) {
      case ModalMode.Details:
        return (
          <TableTemplate
            TableUI={({ reports }) => <CommonTableUI reports={reports} />}
            getDataTable={getOptionsSpecTable}
          />
        );
      case ModalMode.IV:
        return <IVModal />;
      default:
        return null;
    }
  }, [modal]);

  return (
    <div className="flex flex-col justify-start items-start gap-2 relative pt-5 mx-auto p-8 w-full h-full overflow-y-hidden">
      <div className="flex justify-between w-full">
        <OrderBook selectedTableInfo={selectedTableInfo} />
        <div className="flex flex-col justify-between">
          <div className="flex justify-end gap-1 self-end ">
            <FileDownloader getFile={handleExcelDownload} />
            <div className="w-44 self-end">
              {modal !== ModalMode.Closed ? (
                <Modal
                  UI={ModalType}
                  onClose={() => setModal(ModalMode.Closed)}
                />
              ) : (
                <></>
              )}
              <div className="flex gap-3 flex-col">
                <Button
                  onClick={() => setModal(ModalMode.Details)}
                  text="مشخصات قراردادهای اختیار"
                  variant="outlined"
                />
                <Button
                  onClick={() => setModal(ModalMode.IV)}
                  text="پارامترهای بلک شولز"
                  variant="outlined"
                />
              </div>
            </div>
          </div>

          <div className="w-56 flex flex-row justify-start items-center gap-2 self-end">
            <div
              onClick={() => setRefreshFlag(true)}
              className="cursor-pointer mt-5"
            >
              <ReloadOutlined className={refreshFlag ? "animate-spin" : ""} />
            </div>
            <DynamicDropdown
              dropdown={{
                name: "insId",
                placeholder: "نماد",
                extraLabel: true,
              }}
              getData={getOptionsInstruments}
              onChange={searchParamChangeHandler}
              value={searchParam.insId}
            />
          </div>
        </div>
      </div>
      <TableTemplate<
        IUnderlyingAssetsSearchParams,
        IUnderlyingAssetsTableReport
      >
        TableUI={({ reports, onAction, sortingType, setSortingType }) => (
          <CommonTableUI
            reports={reports}
            onAction={onAction}
            sortingType={sortingType}
            setSortingType={setSortingType}
            refreshFlag={refreshFlag}
            tableBoxClassName="max-h-[700px] overflow-auto"
            onTableRowClick={(row) => {
              if (prevRowRef.current === row.id) return;
              prevRowRef.current = row.id;
              setSelectedTableInfo({
                id: row.id,
                contractCode: row.contractCode,
              });
            }}
            activeRowId={selectedTableInfo ? selectedTableInfo?.id : undefined}
          />
        )}
        getDataTable={getOptionsTable}
        withSort
        searchParameters={searchParam}
      />
    </div>
  );
};

export default Options;
